import gql from 'graphql-tag';

/**
 * Mutation to create an inspection instance from a template.
 * Creates a new inspection instance that can be started and completed by an inspector.
 */
export const createInspectionInstanceMutation = gql`
  mutation createInspectionInstance($input: CreateInspectionInstanceInput!) {
    createInspectionInstance(input: $input) {
      id
      schemaVersion
      version
      templateRef {
        templateId
        version
      }
      customName
      metadata {
        buildingId {
          sourceEntityId
          sourceEntityType
          sourceType
        }
        tenantId {
          sourceEntityId
          sourceEntityType
          sourceType
        }
        suiteId {
          sourceEntityId
          sourceEntityType
          sourceType
        }
        assignedTo
        scheduledFor
        scheduleId
        createdAt
        createdBy
      }
      state {
        status
        startedAt
        completedAt
        completedBy
        closedReason
        progress {
          totalItems
          completedItems
          requiredItems
          completedRequiredItems
        }
      }
    }
  }
`;
